/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_OriginInputs */

const en_add_origin = /** @type {(inputs: Add_OriginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Origin`)
};

const es_add_origin = /** @type {(inputs: Add_OriginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar origen`)
};

/**
* | output |
* | --- |
* | "Add Origin" |
*
* @param {Add_OriginInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const add_origin = /** @type {((inputs?: Add_OriginInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_OriginInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_add_origin(inputs)
	return es_add_origin(inputs)
});